import React from 'react';
import PropTypes from 'prop-types';

const FigCaption = ({ children }) => (
  <figcaption className="type-sans-030 mt-2 richtext-figcaption">
    {children}
  </figcaption>
);

FigCaption.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FigCaption;
